import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { eng, tr } from '../util/languageData';
import { isEnglishPath } from '../util/publicRoutes';
import styles from './notFound.module.css';

/**
 * Shown for any URL that is neither a prerendered page nor an app route.
 * the host answers those with HTTP 404 (Cloudflare Pages: build/404.html), so
 * search engines see a real 404 instead of a soft 404; this page helps people
 * on to the right place, in the language of the URL. No canonical and no robots
 * meta: the 404 status already keeps it out of the index.
 */
function NotFound(): JSX.Element {
  const { pathname } = useLocation();
  const english = isEnglishPath(pathname);
  const text = (english ? eng : tr).notFound;
  const prefix = english ? '/en' : '';
  const links = [
    { to: `${prefix}/`, label: text.home },
    {
      to: english ? '/en/gas-station-software/' : '/akaryakit-istasyonu-yazilimi/',
      label: text.software,
    },
    { to: english ? '/en/pricing/' : '/fiyatlandirma/', label: text.pricing },
    { to: `${prefix}/blog/`, label: text.blog },
    { to: `${prefix}/contact/`, label: text.contact },
  ];

  return (
    <div className={styles.page} data-page="not-found">
      <Helmet defer={false}>
        <title>{text.metaTitle}</title>
      </Helmet>
      <div className={styles.container}>
        <p className={styles.code} aria-hidden="true">
          404
        </p>
        <h1 className={styles.title}>{text.title}</h1>
        <p className={styles.text}>{text.text}</p>
        <ul className={styles.links}>
          {links.map((link) => (
            <li key={link.to}>
              <Link to={link.to}>{link.label}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default NotFound;
